import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useEditUserProfile = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("UserProfile/EditUserProfileService", formData);
  });
  return mutation;
};
export default useEditUserProfile;
